var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',_vm._g(_vm._b({staticClass:"form-control",domProps:{"value":_vm.value},on:{"input":event => _vm.$emit('update', event.target.value)}},'textarea',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }